import React, { memo } from 'react'
import { Bullet } from 'components/atoms/icons'
import { IFullStop } from 'types'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { formatCityState } from 'utils/formatCityState'
import formatPhone from 'utils/formatPhone'
import { DISPLAY } from 'constants/display'

interface IMarketplaceFacilityDetailsProps {
  stop?: IFullStop
}

export const MarketplaceFacilityDetails = memo<IMarketplaceFacilityDetailsProps>(({ stop }) => {
  const { getFlag } = useFeatureFlagContext()
  const { enabled: fmsLoadDetailsInformation } = getFlag('fmsLoadDetailsInformation')
  const { enabled: displayFacilityName } = getFlag('displayFacilityName')
  const { shipmentDetails } = useMarketplaceContext()
  const { info: shipmentInfo } = shipmentDetails || {}
  const { carrierId } = shipmentInfo || {}
  const shouldDisplayFacilityName = carrierId || displayFacilityName
  const { facility } = stop || {}
  const {
    companyName: facilityName,
    contactEmail: email,
    contactName: facilityContactName,
    contactPhone: phone,
    contactPhoneExt: phoneExt,
  } = facility || {}
  const {
    address: addressLine1,
    addressLine2,
    city: locality,
    stateCode: subdivisionCode,
    zipcode: postalCode,
  } = facility || {}
  const hasNoContactInfo: boolean = !facilityContactName && !email && !phone
  const phoneExtString = phoneExt ? `Ext. ${phoneExt}` : ``
  return (
    <div className='mb2'>
      {facilityName && shouldDisplayFacilityName ? (
        <span className='b body-medium'>
          {facilityName}
          <br />
        </span>
      ) : (
        <span className='b body-medium'>
          {[locality, subdivisionCode].filter(Boolean).join(', ') || DISPLAY.na}
          <br />
        </span>
      )}
      {addressLine1 && (
        <span>
          {addressLine1}
          <br />
        </span>
      )}
      {addressLine2 && (
        <span>
          {addressLine2}
          <br />
        </span>
      )}
      {(locality || subdivisionCode) && (
        <>
          <span>{formatCityState(locality, subdivisionCode)}</span>
        </>
      )}
      {postalCode && (
        <>
          <span>&nbsp;{postalCode}</span>
          <br />
        </>
      )}
      {hasNoContactInfo && fmsLoadDetailsInformation && <div>No contact information</div>}
      {!hasNoContactInfo && fmsLoadDetailsInformation && (
        <>
          <div>{facilityContactName || 'No contact name'}</div>
          <span className='fs-mask'>
            {phone
              ? `${formatPhone(phone, { removeCountryCode: '+1' })}${
                  phoneExtString ? ` ${phoneExtString}` : ''
                }`
              : 'No phone'}
          </span>
          <Bullet />
          <span className='fs-mask'>{email || 'No email'}</span>
        </>
      )}
    </div>
  )
})
